<template>
    <div class="time-bg">
        <div class="time">
            <div>{{ nowTime }}</div>
            <!-- <img src="@/assets/img/eduBigData/time-bg.png" alt="" /> -->
        </div>
        <!-- <div class="drop-out" @click="$Common.loginOut()">
            <div class="img-1"></div>
            <div class="img-2"></div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'theNowTime',
    components: {},
    props: {},
    data() {
        return {
            nowTime: '',
        }
    },
    created() {
        this.nowTimes()
    },
    mounted() {},
    computed: {},
    watch: {},
    methods: {
        timeFormate(timeStamp) {
            let year = new Date(timeStamp).getFullYear()
            let month =
                new Date(timeStamp).getMonth() + 1 < 10
                    ? '0' + (new Date(timeStamp).getMonth() + 1)
                    : new Date(timeStamp).getMonth() + 1
            let date =
                new Date(timeStamp).getDate() < 10
                    ? '0' + new Date(timeStamp).getDate()
                    : new Date(timeStamp).getDate()
            let hh =
                new Date(timeStamp).getHours() < 10
                    ? '0' + new Date(timeStamp).getHours()
                    : new Date(timeStamp).getHours()
            let mm =
                new Date(timeStamp).getMinutes() < 10
                    ? '0' + new Date(timeStamp).getMinutes()
                    : new Date(timeStamp).getMinutes()
            let ss =
                new Date(timeStamp).getSeconds() < 10
                    ? '0' + new Date(timeStamp).getSeconds()
                    : new Date(timeStamp).getSeconds()
            let week = new Date(timeStamp).getDay()
            let weeks = ['日', '一', '二', '三', '四', '五', '六']
            let getWeek = '星期' + weeks[week]
            this.nowTime =
                year +
                '-' +
                month +
                '-' +
                date +
                ' ' +
                getWeek +
                ' ' +
                hh +
                ':' +
                mm +
                ':' +
                ss
        },
        nowTimes() {
            this.timeFormate(new Date())
            setInterval(this.nowTimes, 1000)
            this.clear()
        },
        clear() {
            clearInterval(this.nowTimes)
            this.nowTimes = null
        }
    },
    destroyed() {},
}
</script>

<style lang="scss" scoped>
.time {
    float: right;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #a6e4f9;
}
img {
    position: absolute;
    top: 0;
    left: 0;
}
.time-bg {
    display: flex;
    flex-direction: row;
}
.drop-out {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .img-1 {
        margin-top: 3.5px;
        margin-left: 8px;
        align-items: center;
        height: 16px;
        width: 53px;
        background: url('~@/assets/img/eduBigData/drop-out-btn.png');
        background-size: 100% 100%;
    }
    .img-2 {
        margin-top: 3.5px;
        height: 5px;
        width: 72px;
        background: url('~@/assets/img/eduBigData/drop-out-line.png');
        background-size: 100% 100%;
    }
}
</style>
